import React from "react";

// Component Imports
import StatusCircleFill from "../StatusCircleFill/StatusCircleFill";

const TransferStatusCell: React.FC<{
  value: string | null | undefined;
}> = React.memo(({ value }) => {
  const grabTransferStatusConfig = () => {
    if (value) {
      switch (value) {
        case "Pending":
          return {
            class: "pulse-color--background-50",
            hex: "#e8eaef",
            percentage_filled: 0,
          };
        case "Complete":
          return {
            class: "pulse-color--success-300",
            hex: "#64e087",
            percentage_filled: 100,
          };
        case "Canceled":
          return {
            class: "pulse-color--background-300",
            hex: "#f2f07e",
            percentage_filled: 0,
          };
        case "Failed":
          return {
            class: "pulse-color--error-200",
            hex: "#ff8f95",
            percentage_filled: 0,
          };
        default:
          return {
            class: "pulse-color--background-200",
            hex: "#939db6",
            percentage_filled: 0,
          };
      }
    }

    return { class: "pulse-color--background-100", hex: "#b6bdce" };
  };

  const config = grabTransferStatusConfig();

  return (
    <div className={`pulse-status-text ${config.class}`}>
      <StatusCircleFill
        percentage={config.percentage_filled || 0}
        primaryColor={config.hex}
        backgroundColor="#0c1835"
      />
      <p className={`pulse-typography-body-1 ${config.class}`}>{value}</p>
    </div>
  );
});

export default TransferStatusCell;
